





























































import VueOptions from '@utils/VueOptions'

settings =
  name: 'FormField'

  vue:
    props: ['value', 'name', 'component', 'errors', 'inputProps', 'options']

    data: ->
      value_: @value
      isFocused: false
      hasChanged: false
      displayErrors: true

    computed:
      required: -> @options?.required || false
      hideName: -> @options?.hideName || false
      instructions: -> @options?.instructions
      why: -> @options?.why
      alwaysShowWhy: -> @options?.alwaysShowWhy
      tips: -> @options?.tips || []
      examples: -> @options?.examples || []
      badExamples: -> @options?.badExamples || []

      showWhy: ->
        return true if @why and @alwaysShowWhy
        return true if @why and @isFocused
        false

      errorMessages: ->
        return [] unless @displayErrors
        return [] unless @hasChanged
        return [] unless @errors
        return @errors if Array.isArray(@errors)
        [@errors]

      hasExamples: -> @examples.length || @badExamples.length

      components: ->
        text: () => import('./FormFields/FormFieldText.vue')
        textarea: () => import('./FormFields/FormFieldTextarea.vue')
        editor: () => import('./FormFields/FormFieldEditor.vue')
        number: () => import('./FormFields/FormFieldNumber.vue')
        select: () => import('./FormFields/FormFieldSelect.vue')
        'checkbox-button': () => import('./FormFields/FormFieldCheckboxButton.vue')
        'radio-button': () => import('./FormFields/FormFieldRadioButton.vue')
        'title-pattern': () => import('./FormFields/FormFieldTitlePattern.vue')
        media: () => import('./FormFields/FormFieldMedia.vue')
        upload: () => import('./FormFields/FormFieldUpload.vue')
        'cloudinary-upload': () => import('./FormFields/FormFieldCloudinaryUpload.vue')
        demographics: () => import('./FormFields/FormFieldDemographics.vue')
        tags: () => import('./FormFields/FormFieldTags.vue')
        storage: () => import('./FormFields/FormFieldStorage.vue')
        'occupancy-count': () => import('./FormFields/FormFieldOccupancyCount.vue')
        'storage-capacity': () => import('./FormFields/FormFieldStorageCapacity.vue')
        'contact-set': () => import('./FormFields/FormFieldContactSet.vue')
        'cancellation-policy': () => import('./FormFields/FormFieldCancellationPolicy.vue')
        'venue-select': () => import('./FormFields/FormFieldVenueSelect.vue')
        'switch': () => import('./FormFields/FormFieldSwitch.vue')
        'text-grid': () => import('./FormFields/FormFieldTextGrid.vue')
        'team-select': () => import('./FormFields/FormFieldTeamSelect.vue')
        'onsite-space-pricing': () => import('./FormFields/FormFieldOnsiteSpacePricing.vue')
        'brand-select': () => import('./FormFields/FormFieldBrandSelect.vue')
        'sponsor-primary-domains': () => import('./FormFields/FormFieldSponsorPrimaryDomains.vue')
        'catex-select': () => import('./FormFields/FormFieldCatexSelect.vue')
        'exclusive-categories': () => import('./FormFields/FormFieldExclusiveCategories.vue')
        'prohibited-categories': () => import('./FormFields/FormFieldProhibitedCategories.vue')
        'seasons': () => import('./FormFields/FormFieldSeasons.vue')
        'blockout-dates': () => import('./FormFields/FormFieldBlockoutDates.vue')
        'inventory-capacity': () => import('./FormFields/FormFieldInventoryCapacity.vue')
        'posting-platforms': () => import('./FormFields/FormFieldPostingPlatforms.vue')
        'physical-signs': () => import('./FormFields/FormFieldPhysicalSigns.vue')
        'omnichannel': () => import('./FormFields/FormFieldOmnichannel.vue')
        'past-relevant-dates': () => import('./FormFields/FormFieldPastRelevantDates.vue')
        'rating': () => import('./FormFields/FormFieldRating.vue')
        'search-address': () => import('./FormFields/FormFieldSearchAddress.vue')
        'shipping-delivery-window': () => import('./FormFields/FormFieldShippingDeliveryWindow.vue')
        'shipping-delivery-timeframe': () => import('./FormFields/FormFieldShippingDeliveryTimeframe.vue')
        'time-picker': () => import('./FormFields/FormFieldTimePicker.vue')

    methods:
      hiInputFocus: ->
        @isFocused = true
        @displayErrors = false

      hiInputBlur: ->
        @isFocused = false

    watch:
      value: (v) ->
        @value_ = v

      value_: ->
        @hasChanged = true unless @hasChanged

      saveRequestIsPending: (value) ->
        @displayErrors = !value

export default VueOptions.vue settings
